import {
    type SaveActionsType,
    CONFIGURATION_ERROR_SAVE,
    CONFIGURATION_FINISH_SAVE,
    CONFIGURATION_START_SAVE,
    CONFIGURATION_INVALIDATE_SAVE,
} from "../actions/SaveActions";
import type { BuildAndBuyActionsType } from "../store";
import type { SaveType } from "../../../../shared-logic/types/SaveTypes";

export type SaveStateType = SaveType & {
    postSaveAction: BuildAndBuyActionsType | null;
};

export const initialState: SaveStateType = {
    saving: false,
    saved: false,
    qrCode: "",
    passbookUrl: "",
    passbookImage: "",
    error: false,
    data: null,
    postSaveAction: null,
};

export default (state: SaveStateType = initialState, action: SaveActionsType): SaveStateType => {
    switch (action.type) {
        case CONFIGURATION_START_SAVE: {
            return { ...initialState, saving: true, error: false, postSaveAction: action.postSaveAction || null };
        }

        case CONFIGURATION_FINISH_SAVE: {
            const { qrCode = "", data } = action;
            return { ...state, saving: false, saved: true, qrCode, data, postSaveAction: null };
        }

        case CONFIGURATION_ERROR_SAVE:
            return { ...initialState, error: true };

        case CONFIGURATION_INVALIDATE_SAVE:
            return { ...initialState, saved: false, saving: false };

        default:
            return state;
    }
};
